export default __webpack_public_path__ + "static/media/Definix-Trading-Challenge-02.e32fa26c.jpg";